export function preloadImage(...urls) {
  let cancelled = false;

  const cancel = () => {
    cancelled = true;
  };

  const createLoadingPromiseExecutor = (url) => (resolve, reject) => {
    const img = new Image();
    img.src = url;

    img.addEventListener('load', () => {
      if (!cancelled) {
        resolve();
      }
    });

    img.addEventListener('error', () => {
      if (!cancelled) {
        reject();
      }
    });
  };

  const loading =
    urls.length === 0
      ? Promise.resolve()
      : Promise.all(
          urls.map((url) => new Promise(createLoadingPromiseExecutor(url)))
        );

  return [cancel, loading];
}
